exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.video-main{position:relative;z-index:-9999999999999\n}\n", "", {"version":3,"sources":["/bitnami/jenkins/home/workspace/web-app.superex.com/src/compontents/newHome/index/IntroModule.vue"],"names":[],"mappings":";AAAA,YAAY,kBAAkB,sBAAsB;CAAC","file":"IntroModule.vue","sourcesContent":[".video-main{position:relative;z-index:-9999999999999}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?sourceMap!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-f6782c7e","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/compontents/newHome/index/IntroModule.vue
// module id = KorS
// module chunks = 0